import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PrivatePagesComponent } from './private-pages.component';
import { CommonsModule } from '../../commons/commons.module';
import { PagesComponentsModule } from '../components/pages-components.module';

@NgModule({
  declarations: [PrivatePagesComponent],
  imports: [CommonModule, CommonsModule, PagesComponentsModule],
})
export class PrivatePagesModule {}
